import Highcharts from "highcharts";
import { kebabCase } from "lodash";
import { locales } from "./dayjs";

export type LocaleCode = keyof typeof locales;

const getLanguageOptions = async (localeCode: LocaleCode): Promise<Highcharts.LangOptions> => {
    try {
        const locale = locales[localeCode];

        return {
            months: locale.months,
            weekdays: locale.weekdays,
            shortMonths: locale.monthsShort,
            shortWeekdays: locale.weekdaysShort,
        };
    } catch (error) {
        console.error("Error: HighCharts localization error", error);
        throw error;
    }
};

export const localizeHighCharts = async (locale: LocaleCode) => {
    const localeCode = kebabCase(locale).toLowerCase();
    if (!localeCode || localeCode === "en" || localeCode === "en-us") {
        /** Reset HighCharts Language */
        Highcharts.setOptions({
            lang: Highcharts.defaultOptions.lang,
        });

        return;
    }

    Highcharts.setOptions({
        lang: await getLanguageOptions(kebabCase(localeCode).toLowerCase() as LocaleCode),
    });
};
